import React from 'react';
import { CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';
import { isObject, getValueColor } from '../../utils/typeChecks';
import {
    getWrapperStyle,
    toggleButtonStyle,
    arrayObjectStyle,
    keyNameStyle,
    keyStyle
} from './jsonNode.styles';
// 1. Context를 사용하기 위한 커스텀 훅을 import 합니다.
import { useJsonViewerContext } from './JsonViewerContext';

// 2. props 목록이 매우 간결해졌습니다.
const JsonNode = ({
                      keyName,
                      value,
                      depth,
                      path,
                  }) => {
    // 3. 필요한 모든 상태와 함수를 Context에서 직접 가져옵니다.
    const { collapsed, toggle } = useJsonViewerContext();

    const isObj = isObject(value);
    const isCollapsed = collapsed[path];

    if (isObj) {
        const entries = Array.isArray(value)
            ? value.map((v, i) => [i, v])
            : Object.entries(value);

        return (
            <div style={getWrapperStyle(depth, false, false)}>
                <div style={toggleButtonStyle} onClick={() => toggle(path)}>
                    {isCollapsed ? <CaretRightOutlined /> : <CaretDownOutlined />}
                    <span style={arrayObjectStyle}>
                        {Array.isArray(value) ? '[...]' : '{...}'}
                    </span>
                    {keyName && (
                        <span style={keyNameStyle}>{keyName}</span>
                    )}
                </div>
                {!isCollapsed &&
                    entries.map(([k, v]) => (
                        <JsonNode
                            key={path + '.' + k}
                            keyName={k}
                            value={v}
                            depth={depth + 1}
                            path={`${path}.${k}`}
                            // 4. 더 이상 하위 노드로 props를 전달할 필요가 없습니다!
                        />
                    ))}
            </div>
        );
    } else {
        // ... (이 부분은 변경 없음)
        return (
            <div style={getWrapperStyle(depth, false, false)}>
                <span>
                    <span style={keyStyle}>{keyName}:</span>{' '}
                    <span style={{ color: getValueColor(value) }}>
                        {JSON.stringify(value)}
                    </span>
                </span>
            </div>
        );
    }
};

export default React.memo(JsonNode);